/* ブログ一覧のカテゴリ絞り込み（NEWS=ドット / COLUMN=タブ。本番 shopify-blog.js の挙動を移植） */
(function () {
  function initFilter(filterSelector, boxId) {
    var filter = document.querySelector(filterSelector);
    var box = document.getElementById(boxId);
    if (!filter || !box) return;
    var items = Array.prototype.slice.call(box.querySelectorAll('.item'));
    var links = Array.prototype.slice.call(filter.querySelectorAll('a'));
    function catFromHref(href) { var m = (href || '').match(/[?&]cat=([^&]+)/); return m ? m[1] : 'all'; }
    function apply(cat) {
      items.forEach(function (el) {
        el.style.display = (cat === 'all' || el.getAttribute('data-cat') === cat) ? '' : 'none';
      });
      links.forEach(function (a) { a.classList.toggle('is-current', catFromHref(a.getAttribute('href')) === cat); });
    }
    links.forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); apply(catFromHref(a.getAttribute('href'))); });
    });
    var params = new URLSearchParams(location.search);
    apply(params.get('cat') || 'all');
  }
  initFilter('.c-dot_filter', 'js-news-list');
  initFilter('.c-tab_filter', 'js-column-grid');
})();
